
    import { defineComponent, PropType } from 'vue';
    import { ConfMenuElem, zone, DCMenuElem, DCMenuConfig, DCConfigurateurModule, DCConfigurateurViewModel,DCConfigurateurModules, PersoConfigView,PersoConfigRequest,typemeta, MCMetaData, PaginationConfEventPage, RenderElemType, ElemConfig, PaginationElemConfig, ImgElemConfig, TextElemConfig, TabElemConfig, GroupeElemConfig, PersoElemConfig, BaliseElemConfig, PartitionConfig, PartitionElemConfig, DCConfigurationViewApiModel, ConfigViewApiModel } from "./../../Scripts/js/detecterconfig";
    import * as dayjs from 'dayjs';
    import * as utc from 'dayjs/plugin/utc';
    dayjs.extend(utc);
    import * as localizedFormat from 'dayjs/plugin/localizedFormat';
    dayjs.extend(localizedFormat);
    import * as duration from 'dayjs/plugin/duration';
    dayjs.extend(duration);
    import * as relativeTime from 'dayjs/plugin/relativeTime';
    dayjs.extend(relativeTime);
    import DcpartitionsComponent from '../../Views/Shared/dcpartitions.vue';
    import EditpersorowsComponent from '../DetecterConfig/editpersorows.vue';
    import axios, { AxiosResponse } from 'axios';

    export default defineComponent({
        components: { DcpartitionsComponent, EditpersorowsComponent },
        data() {
            return {
                modulespersoresume: ((this.$parent) as any).modulespersoresume as DCConfigurateurModules | null,
                opentiroirresume: ((this.$parent) as any).opentiroirresume as string,
                featuresid: ((this.$parent) as any).featuresid as string[],
                dayjs: ((this.$parent) as any).dayjs as any,
                depth: ((this.$parent) as any).depth as number,
                RenderElemType,
                loading: ((this.$parent) as any).loading as boolean,
                idpageselect: ((this.$parent) as any).idpageselect as number,
                idsubpageselect: ((this.$parent) as any).idsubpageselect as number,
                idconfiguser: ((this.$parent) as any).idconfiguser as string,
                page: ((this.$parent) as any).page as number,
                machine: ((this.$parent) as any).machine as number
            }
        },
        props: {
            configuration: DCConfigurationViewApiModel,
            currentlan:String,
            namemodule: String,
            mcpersoaddinfo: String,
            mcpersoaddinfodesc:String,
            mcpersoconfresumetitle: String,
            view_editperso_placeholder_name: String,
            view_editperso_placeholder_value: String,
            deleteconfirm: String,
            oui: String,
            non: String,
            view_configbody_moreinfosbtn: String,
            view_configbody_noinfosupp: String,
            view_configbody_personnaliser: String,
            view_configbody_savebtn: String,
            view_configbody_personnalisersubtitre: String,
            view_configbody_cancelperso: String,
            mcpartitions:String
        },
        mounted() {
        },
        
       
        methods: {
            DCEditModulePersoResume(module: DCConfigurateurModule) {
                let url: string = "/api/v1.0/dcconfigurateur/EditModule";
                let self = this;
                this.loading = true;
                axios.post<boolean>(url, module).then(function (response: AxiosResponse<boolean>) {
                    if (response !== null)
                        if (response.data) {
                            location.reload();
                        }
                        else
                            self.loading = false;
                });
            },
            DCGetModulePersoResume(idmodule: string,lang:string) {
                let url: string = "/api/v1.0/dcconfigurateur/GetModule?idconfig=" + this.idconfiguser + "&idmodule=" + idmodule+"&lang="+lang;
                let self = this;
                axios.get<DCConfigurateurViewModel>(url).then(function (response: AxiosResponse<DCConfigurateurViewModel>) {
                    if (response !== null)
                        if (response.data !== null) {
                            self.modulespersoresume = response.data.m_moduleselect;
                            self.featuresid = [];
                            if (self.modulespersoresume != null) {
                                for (let feature of self.modulespersoresume.features) {
                                    if (feature.ischecked)
                                        self.featuresid.push(feature.id);
                                }
                            }

                        }
                });
            },
            DCOpenTiroirPersoResume(module: string,lang:string) {
                this.opentiroirresume = module;
                this.DCGetModulePersoResume(module, lang);
            },
            DCFermerTiroir() {
                this.opentiroirresume = "";
            },
            DCSavePersoFeatures(lang:string) {
                //this.opentiroirresume = "";
                const request: DCConfigurateurModule = new DCConfigurateurModule();
                if (this.modulespersoresume !== null) {
                    request.id = this.modulespersoresume.id;
                    request.featuresid = this.featuresid;
                    request.lang = lang;
                    this.DCEditModulePersoResume(request);
                }
            },
            DCMoreInfosChild(i: number, j: number, idconfiguser: string, page: number) {
                let event: PaginationConfEventPage = new PaginationConfEventPage();
                event.i = i;
                event.j = j;
                event.idconfiguser = idconfiguser;
                event.page = page;
                this.$emit("dcmoreinfosparent", this.currentlan, event);
            },
        },
    });
